import React from 'react'

function PageFooter() {
    return (
        <footer className="bg-dark text-white p-3 mx-0 w-100">
            <div className="text-center">
            <h6>© Copyright 2020 Rentify - All Rights Reserved</h6>
            </div>
        </footer>
    )
}

export default PageFooter
